import Vue from 'vue';
import * as Sentry from '@sentry/browser';

import store from '@state/store';
import config from './config';
import packageJson from '../package.json';

export default function initializeSentry() {
  validateProject();

  Sentry.init({
    beforeSend(event) {
      event.user = {
        username: store.getters['auth/userName'],
        email: store.getters['auth/userEmail'],
      };

      return event;
    },
    dsn: config.SENTRY_DSN,
    integrations: [
      new Sentry.Integrations.Vue({ Vue, attachProps: true }),
    ],
    release: `${packageJson.name}@${packageJson.version}`,
    environment: config.SENTRY_ENV,
  });
}

function validateProject() {
  if (!packageJson.name || !packageJson.version) {
    throw new Error('Please specify project name & version in package.json');
  } else if (packageJson.name === 'nucleus-dashboard') {
    throw new Error('Please update your project name in package.json');
  }
}
